import React from "react";
//MUI
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import CategoriesComboBox from "Components/Option/CategoriesComboBox";

export default function OptionFormGeneral({
  formData,
  categories,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: "10px" }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            label="ID"
            value={formData.Id}
            // onChange={(e) => handleInputChange("Id", e.target.value)}
            disabled
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            label="Namn"
            value={formData.Name}
            onChange={(e) => handleInputChange("Name", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            label="Kategori"
            value={formData.Category}
            onChange={(e) => handleInputChange("Category", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            label="Värde"
            value={formData.Value}
            rows={6}
            multiline
            onChange={(e) => handleInputChange("Value", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>

        {/* <Grid item xs={12} sm={6} md={4}>
                    <CategoriesComboBox
                        label={"Kategori"}
                        categories={categories}
                        // value={formData.Category}
                        selectedCategory={formData.categories}
                        // onChange={(newVal) => handleInputChange("Category", newVal)}
                    />
                </Grid> */}
      </Grid>
    </>
  );
}
